import React from 'react';
import { motion } from 'framer-motion';

/**
 * Animated signal bars that appear above the bot icon during streaming
 */
export function SignalBars({ isActive }) {
  if (!isActive) return null;

  return (
    <div className="absolute -top-3 left-1/2 -translate-x-1/2 flex items-end gap-0.5">
      {/* Bar 1 - shortest */}
      <motion.div
        className="w-1 bg-violet-400 rounded-full"
        initial={{ height: 4 }}
        animate={{
          height: [4, 8, 4],
          opacity: [0.4, 1, 0.4]
        }}
        transition={{
          duration: 1.2,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0
        }}
      />

      {/* Bar 2 - medium */}
      <motion.div
        className="w-1 bg-violet-400 rounded-full"
        initial={{ height: 6 }}
        animate={{
          height: [6, 10, 6],
          opacity: [0.4, 1, 0.4]
        }}
        transition={{
          duration: 1.2,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.2
        }}
      />

      {/* Bar 3 - tallest */}
      <motion.div
        className="w-1 bg-violet-400 rounded-full"
        initial={{ height: 8 }}
        animate={{
          height: [8, 12, 8],
          opacity: [0.4, 1, 0.4]
        }}
        transition={{
          duration: 1.2,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.4
        }}
      />
    </div>
  );
}
